import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[doesntEqualTo]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: DoesntEqualToValidator, multi: true }
    ],
    standalone: false
})
export class DoesntEqualToValidator  extends BaseValidator implements OnChanges {

  @Input('doesntEqualTo')
  otherValue: string;

  @Input('doesntEqualTo_comparisonType')
  comparisonType: string;

  @Input('doesntEqualTo_fieldName')
  fieldName: string;

  @Input('doesntEqualTo_source')
  source: string = null;

  @Input('doesntEqualTo_validationMessage')
  validationMessage: string;

  constructor() {
    super('doesntEqualTo');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.otherValue && changes.otherValue.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {
    if (this.source === null && (!control.value || !this.otherValue)) {
      return null;
    }
    
    let firstValue: any = control.value;
    let secondValue: any = this.otherValue;
    if (this.comparisonType === "Date") {
      firstValue = new Date(control.value);
      secondValue = new Date(this.otherValue);
    }

    if (firstValue != secondValue)
      return null;

    var result = { fieldName: this.fieldName } as any;
    if (this.validationMessage) {
      result.error = this.validationMessage;
    }

    return this.buildValidationErrorResult(result);
  }
}
